"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: "user-name-input",
    props: {
        initValue: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            name: "user-name-input",
            value: this.initValue
        };
    },
    watch: {
        initValue: function () {
            this.value = this.initValue;
        }
    },
    methods: {
        isValid: function (emitValidation) {
            if (emitValidation === void 0) { emitValidation = false; }
            if (!!this.value.trim()) {
                return true;
            }
            if (emitValidation) {
                this.$emit("invalid");
            }
        },
        updateValue: function (value) {
            this.value = value;
            this.$emit("input", value);
        },
        onBlur: function () {
            this.appendValidationClass();
        },
        appendValidationClass: function () {
            var ref = this.$refs.userName;
            if (!ref || !ref.classList) {
                return;
            }
            if (this.isValid()) {
                ref.classList.remove("is-invalid");
                ref.classList.add("is-valid");
            }
            else {
                ref.classList.remove("is-valid");
                ref.classList.add("is-invalid");
            }
        }
    }
});
